import { io } from "socket.io-client";
import { isIpAddressOrDomain } from "../../utils/functions";

const SERVER_URL = isIpAddressOrDomain(true);
// const TOKEN = localStorage.getItem("token");

export const socket = io(SERVER_URL, {
  autoConnect: false,
  reconnection: true,
  //   auth: {
  //     token: TOKEN,
  //   },
  transports: ["websocket"],
  path: "/terminal",
});
